export const isExternal = (url: string, siteBasePath: string): boolean => {
  const isAbsoluteUrl = url.startsWith("http://") || url.startsWith("https://");

  if (!isAbsoluteUrl) {
    return false;
  }

  try {
    const urlObj = new URL(url);
    const currentOrigin =
      typeof window !== "undefined"
        ? window.location.origin
        : process?.env?.APP_ORIGIN || "";

    if (currentOrigin && urlObj.origin !== currentOrigin) {
      return true;
    }

    const pathname = urlObj.pathname;

    if (!pathname.startsWith(siteBasePath + "/") && pathname !== siteBasePath) {
      return true;
    }

    return false;
  } catch {
    return false;
  }
};
